import React, { FC, ReactElement, ReactNode } from 'react';
import { Tooltip, TooltipProps } from '@material-ui/core';
import styles from './WrapperWithHoverableTooltip.module.scss';
import clsx from 'clsx';

export interface WrapperWithHoverableTooltipProps {
  tooltip: ReactNode;
  className?: string;
  placement?: TooltipProps['placement'];
}

const WrapperWithHoverableTooltip: FC<WrapperWithHoverableTooltipProps> = ({
  tooltip,
  children,
  className,
  placement = 'bottom-start',
}) => {
  return (
    <Tooltip
      classes={{ popperInteractive: clsx(styles.tooltip, className) }}
      title={tooltip || ''}
      placement={placement}
      interactive
      arrow
    >
      {children as ReactElement}
    </Tooltip>
  );
};

export default WrapperWithHoverableTooltip;
